module.exports = __webpack_public_path__ + "static/media/0.6e5a7ee0.svg";